"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hiddenUploadElementHtml = exports.default = void 0;

var _translations = require("../../libs/translationsUtils/translations");

// this list only for filtering files extensions in the browser dialog window
// it's not related to types validation
var allowedFileTypes = ['zip', 'pdf', 'xml', 'txt', 'csv', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'jpg', 'jpeg', 'gif', 'png', 'webp', 'olf', '8bf', 'abf', 'abr', 'act', 'aep', 'afm', 'ai', 'arw', 'as', 'ase', 'avi', 'bmp', 'book', 'cel', 'cfc', 'chproj', 'cptx', 'cr2', 'cr3', 'crf', 'crw', 'css', 'dn', 'dng', 'eps', 'epub', 'exif', 'fbx', 'fla', 'flac', 'flv', 'fm', 'icma', 'icml', 'ico', 'ics', 'idml', 'indd', 'jsfl', 'json', 'log', 'loss', 'lrcat', 'lrtemplate', 'm4a', 'mif', 'mov', 'mp3', 'mp4', 'mpg', 'nef', 'nrw', 'obj', 'odt', 'orf', 'otc', 'otf', 'pfb', 'pfm', 'pmd', 'ppj', 'prc', 'prel', 'prproj', 'ps', 'psb', 'psd', 'raf', 'raw', 'rtf', 'sbs', 'sbsar', 'sbsm', 'scc', 'ses', 'sesx', 'skp', 'sol', 'srt', 'srw', 'ssa', 'stl', 'svg', 'swf', 'tif', 'ttc', 'ttf', 'wav', 'wmv', 'x3f', 'xd', 'xmp', 'psap', 'heic', 'cpd', 'gz', 'tar.gz', 'har', 'mpeg', 'odp', 'ods', 'pps', 'rar', 'rm', 'tiff', 'xlr', 'z', '7z', 'ioc', 'hex', 'c', 'cc', 'cpp', 'h', 'hpp', 'tar', 'xz', 'dts', 's'];
var hiddenUploadElementHtml = "<input class=\"attachment-uploader\" type=\"file\" accept=\"".concat(allowedFileTypes.map(function (type) {
  return '.' + type;
}).join(', '), "\" multiple=\"multiple\" />");
exports.hiddenUploadElementHtml = hiddenUploadElementHtml;

var createInputField = function createInputField(editor) {
  var hiddenUploadElement = window.CKEDITOR.dom.element.createFromHtml(hiddenUploadElementHtml);
  hiddenUploadElement.appendTo(editor.element);
  hiddenUploadElement.on('change', function (e) {
    var target = e.data.getTarget();

    if (target.$.files.length) {
      editor.fire('fileAttachment', {
        files: target.$.files
      });
    }
  });
  return hiddenUploadElement;
}; // eslint-disable-next-line import/no-anonymous-default-export


var _default = {
  init: function init(editor) {
    var commandName = 'addInsidedAttachment';
    editor.ui.addButton('InsidedAttachment', {
      label: (0, _translations.t)('Forum', 'wysiwyg.links.btn.upload'),
      command: commandName,
      icon: 'insided-icons/attach-file.svg',
      toolbar: 'insert,0'
    });
    var hiddenUploadElement = createInputField(editor);
    editor.addCommand(commandName, {
      exec: function exec() {
        hiddenUploadElement.$.click();
        hiddenUploadElement.remove();
        hiddenUploadElement = createInputField(editor);
      }
    });
  }
};
exports.default = _default;